import Swiper from "swiper/bundle";

const Header = {
  el: $(".header"),
  cookie_bar: $("#cookies"),

  init: function () {
    Header.events();
    Header.mobile();

    Header.scroll();
    $(window).on("scroll", Header.scroll);

    Header.mobile_menu();
    $(window).on("resize", Header.mobile_menu);

    Header.setMenuHeight();
    $(window).on("resize", Header.setMenuHeight);

    Header.smallInfoSlider();
  },

  events: function () {

    let hoverTimeout = false;
    let visibleTimeout = false;
    let visible = false;

    $(".main-nav > .menu-item.menu-item-has-children").on(
      "mouseenter",
      function () {
        const item = $(this);

        if (visible == item.attr("id")) {
          clearTimeout(hoverTimeout);
        }

        if (visible) {
          hoverTimeout = setTimeout(function () {
            visible = item.attr("id");
          }, 250);
        } else {
          visible = item.attr("id");
        }

        visibleTimeout = setTimeout(function () {
          Header.handleItemVisibility(visible);
        }, 300);
      }
    );

    $(".main-nav").on("mouseleave", function () {
      visible = false;
      clearTimeout(hoverTimeout);
      clearTimeout(visibleTimeout);
      $(".sub-menu").removeClass("visible");
    });
  },

  handleItemVisibility: function (visible) {
    $(".menu-item").each(function () {
      const item = $(this);
      if (item.attr("id") === visible) {
        item.children(".sub-menu").addClass("visible");
      } else {
        item.children(".sub-menu").removeClass("visible");
      }
    });
  },

  mobile: function () {
    // toggle main navigation mobile
    $(".toggle-menu").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("burger--open");

      Header.el.toggleClass(
        "header--was-scrolled",
        Header.el.hasClass("header--scrolled")
      );
      Header.el.toggleClass("header--mobile-open");

      $("html").toggleClass("no-scroll");
    });

    // Submenu functionality
    let menus = $(
      ".header-mobile__navigation .menu > li.menu-item-has-children"
    );

    menus.each(function () {
      let item = $(this).children("a");
      $(this)
        .children(".sub-menu")
        .prepend(
          `<div class="sub-menu-title"><span></span><a href="${item.attr(
            "href"
          )}">${item.text()}</a></div>`
        );
    });

    menus.click(function () {
      if ($(this).hasClass("menu-item-has-children")) {
        $(this).children(".sub-menu").addClass("open");
      }
    });

    $(".header-mobile__navigation").on(
      "click",
      ".sub-menu-title span",
      function () {
        $(this).closest(".sub-menu").removeClass("open");
      }
    );
  },

  setMenuHeight: function () {
    let height = $(window).innerHeight();
    height -= 72;

    $(".header-mobile").css({
      height: height,
    });
  },

  scroll: function () {
    if ($(window).scrollTop() > 100) {
      Header.el.addClass("header--scrolled");
    } else {
      Header.el.removeClass("header--scrolled");
    }
  },

  mobile_menu: function () {
    if ($(window).width() < 1200) {
      var height = Header.el.height();
      if (Header.cookie_bar.length) {
        height += Header.cookie_bar.height();
      }
      $(".prod-cats__list").css("padding-bottom", height);
    } else {
      $(".prod-cats__list").css("padding-bottom", 0);
    }
  },

  smallInfoSlider() {
    const wrapEl = $(".small-info-slider");
    if (!wrapEl) {
      return
    } else {

      const prevEl = wrapEl.find(".swiper-nav-button--prev")[0];
      const nextEl = wrapEl.find(".swiper-nav-button--next")[0];

      let swiper = new Swiper(wrapEl.find(".swiper")[0],
        {
          loop: true,
          autoplay: true,
          spaceBetween: 16,
          navigation: {
            prevEl: prevEl,
            nextEl: nextEl,
          },
        })
    }
  },
};

export default Header;
